import * as LiveSetupSteps from "./liveSetupSteps";
import { LiveSessionScheduleForm } from "../models/LiveSessionScheduleForm";

export const getInitialCourseState = () => ({
  loading: false,
  errorFetching: false,
  course: {
    id: null,
    livePlaceholder: "",
    numberOfStudents: null,
    openGraphCover: "",
    title: "",
    teacher: {
      id: null,
      name: "",
      avatar: {},
    },
  },
});

export const getInitialLiveFeedbackAnswersState = () => ({
  loading: false,
  errorSaving: false,
  answersSentSuccess: false,
});

export const getInitialLiveFeedbackQuestionsState = () => ({
  loading: false,
  errorFetching: false,
  liveFeedbackQuestionsFetched: false,
  liveFeedbackQuestions: [],
});

export const getInitialLiveChannelState = () => ({
  loading: false,
  errorFetching: false,
  liveChannel: {
    id: null,
    playbackUrl: "",
    streamKeyValue: "",
    ingestEndpoint: "",
  },
});

export const getInitialLiveSessionState = () => ({
  loading: false,
  errorFetching: false,
  errorSaving: false,
  liveSessionFetchSuccess: false,
  liveSessionCreated: false,
  liveSessionUpdated: false,
  readyStateSuccess: false,
  streamingStateSuccess: false,
  finishedStateSuccess: false,
  cancelledStateSuccess: false,
  liveSession: {
    id: null,
    aasmState: "",
    title: "",
    playerToken: "",
    hasRecording: false,
  },
  liveChannel: {
    streamKeyValue: "",
    ingestEndpoint: "",
    playbackUrl: "",
  },
  webSocket: {
    authKey: "",
    stateChannel: {
      channelName: "",
      presenceChannelName: "",
    },
    chatChannel: {
      channelName: "",
      presenceChannelName: "",
    },
  },
  recording: {
    url: "",
  },
});

export const getInitialLiveSessionStateDomain = () => ({
  loading: false,
  errorFetching: false,
  errorSaving: false,
  liveSessionFetchSuccess: false,
  liveSessionCreated: false,
  liveSessionUpdated: false,
  readyStateSuccess: false,
  streamingStateSuccess: false,
  finishedStateSuccess: false,
  cancelledStateSuccess: false,
  liveSession: {
    id: null,
    aasmState: "",
    title: "",
    hasRecording: false,
  },
  pnWebsockets: {
    authKey: "",
    stateChannel: {
      channelName: "",
      presenceChannelName: "",
    },
    chatChannel: {
      channelName: "",
      presenceChannelName: "",
    },
  },
  recording: {
    url: "",
  },
  streaming: {
    playerToken: "",
    playbackUrl: "",
  },
});

export const getInitialLiveSessionsListState = () => ({
  loading: false,
  errorFetching: false,
  liveSessionFetchSuccess: false,
  liveSessionsList: [],
  liveSessionsListNextPage: 1,
  isLastLiveSessionsListPage: false,
});

export const getInitialLiveStreamState = () => ({
  loadingEntrypointsLives: false,
  errorFetchingEntrypointsLives: false,
  loadingFeaturedLives: false,
  errorFetchingFeaturedLives: false,
  loadingNextLives: false,
  errorFetchingNextLives: false,
  entrypointsLives: [],
  featuredLives: [],
  nextLives: [],
});

export const getInitialLiveSessionSchedulePageState = () => ({
  loading: false,
});

export const getInitialLiveSessionsListPageState = () => ({
  loading: false,
});

export const getInitialLivePageState = () => ({
  loading: false,
});

export const getInitialLiveSetupState = () => ({
  loading: false,
  liveSetup: {
    step: LiveSetupSteps.CREDENTIALS_SETUP,
  },
});

export const getInitialPubnubCredentialsState = () => ({
  loading: false,
  errorFetching: false,
  pubnubCredentials: {
    publishKey: "",
    subscribeKey: "",
  },
});

export const getInitialUserState = () => ({
  loadingJWT: false,
  loadingUser: false,
  errorFetchingJWT: false,
  errorFetchingUser: false,
  jwt: "",
  user: {
    id: null,
    permalink: "",
    avatar: "",
  },
});

export const getInitialUserLiveSessionState = () => ({
  loading: false,
  userLiveSessionCreated: false,
  userLiveSessionFinished: false,
  errorCreating: false,
  errorFinishing: false,
});

export const getInitialScheduleFormState = ({ initialData, skipFieldValidations = false } = {}) =>
  new LiveSessionScheduleForm({ initialData, skipFieldValidations });
